import { BaseRouteService } from "core/services";

class NikoPatientTemplateItemRouteService extends BaseRouteService {
  constructor() {
    super('patient-template-item');
  }

  create() {
    return this.base;
  }

  update(id) {
    return `${this.base}/${id}`;
  }

  delete(id) {
    return `${this.base}/${id}`;
  }

  calculateQuantity(resource) {
    return super.update(this.base + `/calculate-quantity`, resource);
  }

  createAdditionalItems(resource) {
    return super.create(this.base + `/additional-items`, resource);
  }

  createAdditionalTrachItems(resource) {
    return super.create(this.base + `/additional-trach-items`, resource);
  }

  findAndReplaceItem(resource) {
		return super.update(`${this.base}/find-and-replace-item`, resource);	
	}

  calculateReplacementItemsQuantity(resource){
		return super.batchUpdate(`${this.base}/calculate-replacement-items-quantity`, resource);	
	}

  findAndDeleteItem(resource) {
		return super.update(`${this.base}/find-and-delete-item`, resource);
	}

  getNikoOrderSummaryItems(filter) {
    return super.find(`${this.base}/niko-order-summary/{?facilityOrderId,itemCategoryId,productId}`, filter);
  }

  nikoCutbackSalesOrderQuantities(resource) {
    return super.update(`${this.base}/niko-cutback-sales-order-quantities`, resource);
  }

  nikoUpdateSendSeparatelyQuantity(resource) {
    return super.update(`${this.base}/niko-update-send-separately-quantity`, resource);
  }

  nikoUpdateBatchSendSeparatelyQuantity(resource) {
    return super.update(`${this.base}/niko-update-send-separately-quantity/batch-distribution`, resource);
  }

  nikoRoundToTheNearestCase(resource) {
    return super.update(`${this.base}/niko-round-to-the-nearest-case/{?facilityOrderId,productId}`, resource);
  }
}

export default NikoPatientTemplateItemRouteService;